<template>
  <div>
    <div v-if="withTitle" class="flex items-center justify-between mb-16">
      <RevSkeleton height="32px" shape="rectangle" width="190px" />
      <!-- skeleton for arrow buttons -->
      <RevSkeleton
        v-if="layout === 'carousel'"
        class="max-md:hidden"
        height="40px"
        shape="rectangle"
        width="92px"
      />
    </div>
    <ul
      class="gap-8 md:gap-16 overflow-hidden scrollbar-none gradient-mask-r-90 pb-20"
      :class="{
        'grid grid-standard md:col-span-2 lg:col-span-3': layout === 'grid',
        flex: layout === 'carousel',
      }"
    >
      <RevSkeleton
        v-for="i in 8"
        :key="i"
        :class="{
          'md:col-span-2 lg:col-span-3': layout === 'grid',
          'min-w-256': layout === 'carousel',
        }"
        height="280px"
        shape="rectangle"
        width="256px"
      />
    </ul>

    <!-- skeleton for arrow buttons -->
    <div v-if="!withTitle && layout === 'carousel'" class="flex justify-end">
      <RevSkeleton
        class="max-md:hidden"
        height="40px"
        shape="rectangle"
        width="92px"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'

const { layout = 'carousel', withTitle } = defineProps<{
  layout?: 'grid' | 'carousel'
  withTitle?: boolean
}>()
</script>
